import "./BottomAdvertisement.scss";
import images from "../../assets/images";
import { FC, useEffect, useState } from "react";
import { SCHOOL_ADMIN } from "../../utils/constants";
import { useAppSelector } from "../../redux/app/hooks";

interface PropsType {
  adImage: string;
  handlecloseAd? : () => void
  showcloseIcon ? : boolean
}
const BottomAdvertisement: FC<PropsType> = ({ adImage, handlecloseAd, showcloseIcon }) => {
  const {closeIconround} = images
  const role = useAppSelector((state) => state.auth.role);

  const [loadFailed, setLoadFailed] = useState<boolean>(false);

  // A new image gets a fresh chance to load
  useEffect(() => {
    setLoadFailed(false);
  }, [adImage]);

  // Don't reserve any space when there is no usable ad image (missing, blank, or failed to load)
  if (!adImage?.trim() || loadFailed || role === SCHOOL_ADMIN) return null;

  return (
    <div className="bottomAdContainer">
      <img src={adImage} alt="adImage" className="bottomAdStyle" onError={() => setLoadFailed(true)} />
      {showcloseIcon && <img className="close-ad-button" onClick={handlecloseAd} alt="close" src={closeIconround}/>}
    </div>
  );
};

export default BottomAdvertisement;
